import styled, { css } from 'styled-components';

export type TooltipRects = {
  surfaceRect?: DOMRect;
  gridRect?: DOMRect;
};

export type chartMargins = {
  top: number;
  left: number;
  right: number;
  bottom: number;
};
type OpacityContainerProps = {
  xCoordinate: number;
  chartRects: TooltipRects;
  yAxisOrientation?: 'left' | 'right';
  marginLeft?: number;
  margin?: chartMargins;
};

type CoordinateProps = OpacityContainerProps & {
  containerWidth: number;
};

const calculateLeftAmount = ({
  chartRects,
  containerWidth,
  xCoordinate,
}: CoordinateProps) => {
  const chartWidth = chartRects.gridRect?.width ?? 0;

  if (xCoordinate <= containerWidth / 2) {
    return 0;
  } else if (xCoordinate >= chartWidth - containerWidth / 2) {
    return chartWidth - containerWidth;
  } else {
    return xCoordinate - containerWidth / 2;
  }
};

export const Container = styled.div<CoordinateProps>`
  display: flex;
  width: max-content;
  justify-content: center;
  align-items: center;
  padding: 0.2rem 0.8rem;
  background-color: ${({ theme }) => theme.colors.surface.default};
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
  gap: 0.8rem;
  top: -3rem;
  position: absolute;
  left: ${(props) => `${calculateLeftAmount(props)}px`};
  transform: unset;
  z-index: ${({ theme }) => theme.zIndex.low};
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  img,
  svg {
    height: 1.8rem;
    width: 1.8rem;
  }
`;

export const TextWrapper = styled.div`
  gap: 5.1rem;
  margin-bottom: 1.9rem;
  display: flex;
  justify-content: space-between;
`;

export const OpacityContainer = styled.div<OpacityContainerProps>`
  position: absolute;
  top: 0;
  bottom: 30px;

  left: ${({ xCoordinate, chartRects, yAxisOrientation, margin }) => {
    if (yAxisOrientation != 'left') {
      const leftDistance = xCoordinate - (margin?.left || 0);

      return `${leftDistance}px`;
    }

    const { gridRect, surfaceRect } = chartRects;

    if (!surfaceRect || !gridRect) {
      return '';
    }

    const leftSpace = surfaceRect.width - gridRect.width - (margin?.right || 0);

    return `${xCoordinate - leftSpace}px`;
  }};

  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0px,
    rgba(255, 255, 255, 0.7) 8px
  );

  ${({ chartRects }) => {
    const { gridRect, surfaceRect } = chartRects;

    if (!surfaceRect || !gridRect) {
      return '';
    }

    const widthDiff = surfaceRect.width - gridRect.width;
    const heightDiff = surfaceRect.height - gridRect.height;

    return css`
      bottom: ${heightDiff}px;
      right: ${widthDiff}px;
    `;
  }}
`;
